import { CredentialStatus } from '@seek/ca-myprofile-utils';
import { SeekPassIconVerified } from '@seek/certsy-ui';
import { useTranslations } from '@vocab/react';
import {
  Text,
  Stack,
  Box,
  Secondary,
  Inline,
  Badge,
  Strong,
} from 'braid-design-system';
import type React from 'react';

import { RightToWorkCertsyLink } from 'src/components/Profile/NextRole/RightToWork/RightToWorkCertsyLink/RightToWorkCertsyLink';
import type { RightToWorkCredential } from 'src/components/Profile/NextRole/RightToWork/types';

import translations from './.vocab';

interface ComponentProps {
  certsyRightToWork: RightToWorkCredential;
  label?: string;
  rightToWorkRef?: React.RefObject<HTMLElement>;
}

export const RightToWorkCertsyBox = ({
  certsyRightToWork,
  label,
  rightToWorkRef,
}: ComponentProps) => {
  const { t } = useTranslations(translations);
  const {
    status,
    expiryFormatted,
    verification: { result: workRightText },
    manageVerificationUrl,
  } = certsyRightToWork;

  return (
    <Box ref={rightToWorkRef}>
      <Stack space="xsmall">
        {typeof label !== 'undefined' && <Text weight="strong">{label}</Text>}
        <Box
          boxShadow="borderNeutralLight"
          padding="medium"
          borderRadius="standard"
        >
          <Stack space="small">
            {status && (
              <Inline space="xsmall">
                {status === CredentialStatus.New && (
                  <Badge tone="positive">{t('New')}</Badge>
                )}
              </Inline>
            )}
            <Inline space="xxsmall">
              <Text>
                <Strong>{t('Verified')} </Strong>
                <SeekPassIconVerified />
              </Text>
              <RightToWorkCertsyLink
                linkAction="manage"
                linkUrl={manageVerificationUrl}
              />
            </Inline>
            <Text>
              <Secondary>{expiryFormatted}</Secondary>
            </Text>
            <Text>{workRightText}</Text>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};
